import { Reveal, Overline } from "@/components/Motion";
import { IMAGES } from "@/data/content";

const Welcome = () => (
  <section id="welcome" className="py-28 sm:py-36 lg:py-44 overflow-hidden" data-testid="welcome-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16 lg:gap-10 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <Overline className="text-wine">Benvenuti</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight mt-5">
            Benvenuti to <span className="italic text-wine">Forco Amore</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-faded text-base md:text-lg font-light leading-relaxed">
            Forco Amore is where the romance of Italy meets the warmth of India. Our pasta is
            rolled by hand each morning, our dals simmer overnight, and every ingredient is chosen
            with obsessive care — traditional techniques, presented with a contemporary, romantic touch.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-10 flex items-center gap-6">
            <span className="h-px w-16 bg-wine/40" />
            <p className="font-serif italic text-xl text-ink/80">La cucina è amore — the kitchen is love</p>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 lg:pl-16">
        <Reveal delay={0.15} y={60}>
          <div className="relative">
            <div className="absolute -top-5 -right-5 h-full w-full rounded-[2rem] border border-wine/25" aria-hidden="true" />
            <div className="group relative overflow-hidden rounded-[2rem]">
              <img
                src={IMAGES.welcome}
                alt="Our signature dal makhani, simmered overnight and finished with cream"
                loading="lazy"
                className="img-lux w-full aspect-[4/3] object-cover"
                data-testid="welcome-image"
              />
            </div>
            <p className="mt-5 text-xs tracking-[0.3em] uppercase text-faded">Simmered overnight — our signature dal makhani</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Welcome;
